import { Icon } from "@iconify/react/dist/iconify.js";
import { Table } from "antd";
import React from "react";

const DataTable = () => {
  const dataSource = [
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
    {
      key: "1",
      name: "Floor 1",
      time: "12:45 pm",
    },
    {
      key: "2",
      name: "John",
      time: "12:45 pm",
    },
  ];
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Time",
      dataIndex: "Time",
      key: "age",

      render: (text, record) => <>{record.time}</>,
    },
    {
      title: "Time",
      dataIndex: "Time",
      key: "age",

      render: (text, record) => (
        <>
          <span className="view-btn">View</span>
        </>
      ),
    },
  ];

  return (
    <div>
      <div className="data-table-wrapper">
        <div className="header">
          <h3>History</h3>
          <div className="input-box">
            <div className="icon-box">
              <Icon
                icon="ic:round-search"
                width="24"
                height="24"
                style={{ color: "#B4B4B4" }}
              />
            </div>
            <input type="text" placeholder="Search" />
          </div>
        </div>
        <Table dataSource={dataSource} columns={columns} />;
      </div>
    </div>
  );
};

export default DataTable;
